import React from "react";
import { API_BASE_URL } from "../../API/endpoint";

export const OrderDetailsModal = ({ order, getThumbnailUrl, onClose, setViewingImage }) => {
  if (!order) return null;

  const totalQuantity = order.items.reduce((sum, item) => sum + item.quantity, 0);
  // Utiliser les valeurs réelles de la commande si disponibles, sinon calculer
  const shippingCost = order.shippingCost ? parseFloat(order.shippingCost) : (() => {
    if (totalQuantity >= 10) return 15;
    else if (totalQuantity >= 6) return 9;
    else if (totalQuantity >= 3) return 7;
    else if (totalQuantity >= 1) return 5;
    return 0;
  })();
  const shippingMethod = order.shippingMethod || 'colissimo';
  const sousTotal = order.items.reduce((sum, item) => sum + parseFloat(item.product ? item.product.price : item.price) * item.quantity, 0);
  const totalWithShipping = sousTotal + shippingCost;

  return (
    <div className="order-details-modal" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h3>Détails de la commande #{order.id}</h3>
          <button className="btn-cancel bi bi-x-square" onClick={onClose}>
            
          </button>
        </div>

        <div className="order-details-content">
          <div className="order-info-section client-info">
            <div className="section-icon">👤</div>
            <div className="section-content">
              <h4>Client</h4>
              <p className="info-value">
                {order.payerFirstName && order.payerLastName
                  ? `${order.payerFirstName} ${order.payerLastName}`
                  : order.utilisateur
                  ? `${order.utilisateur.prenom} ${order.utilisateur.nom}`
                  : "N/A"}
              </p>
              {order.payerEmail && (
                <p className="info-label">
                  <span className="info-value">{order.payerEmail}</span>
                </p>
              )}
              {order.shippingPhone && (
                <p className="info-label">
                  Tél: <span className="info-value">{order.shippingPhone}</span>
                </p>
              )}
            </div>
          </div>

          <div className="order-info-section payment-info">
            <div className="section-icon">💰</div>
            <div className="section-content">
              <h4>Détails de paiement</h4>
              <div className="payment-details">
                <div className="payment-row">
                  <span className="payment-label">Sous-total:</span>
                  <span className="payment-value">{sousTotal.toFixed(2)} €</span>
                </div>
                <div className="payment-row">
                  <span className="payment-label">Livraison:</span>
                  <span className="payment-value">
                    {shippingMethod === 'pickup' ? 'Retrait en magasin' : 'Colissimo'} ({shippingCost.toFixed(2)} €)
                  </span>
                </div>
                <div className="payment-row payment-total">
                  <span className="payment-label">Total:</span>
                  <span className="payment-value">{totalWithShipping.toFixed(2)} €</span>
                </div>
                <div className="payment-row">
                  <span className="payment-label">Statut:</span>
                  <span className={`payment-status status-${order.status.toLowerCase()}`}>
                    {order.status}
                  </span>
                </div>
                <div className="payment-row">
                  <span className="payment-label">Payment ID:</span>
                  <span className="payment-value">{order.paymentId}</span>
                </div>
                <div className="payment-row">
                  <span className="payment-label">Date:</span>
                  <span className="payment-value">
                    {new Date(order.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="order-info-section shipping-info">
            <div className="section-icon">📦</div>
            <div className="section-content">
              <h4>Adresse de livraison</h4>
              {order.shippingAddress ? (
                <div className="shipping-address">
                  {((order.shippingName && order.shippingLastName) ||
                    (order.payerFirstName && order.payerLastName) ||
                    order.utilisateur) && (
                    <p className="shipping-name">
                      {order.shippingName && order.shippingLastName
                        ? `${order.shippingName} ${order.shippingLastName}`
                        : order.payerFirstName && order.payerLastName
                        ? `${order.payerFirstName} ${order.payerLastName}`
                        : `${order.utilisateur.prenom} ${order.utilisateur.nom}`}
                    </p>
                  )}
                  <p>{order.shippingAddress}</p>
                  {order.shippingAddressLine2 && <p>{order.shippingAddressLine2}</p>}
                  <p>
                    {order.shippingPostalCode} {order.shippingCity}
                  </p>
                  <p>{order.shippingCountry}</p>
                </div>
              ) : (
                <p className="no-address">
                  Adresse non disponible (commande créée avant l'ajout de cette fonctionnalité)
                </p>
              )}
            </div>
          </div>

          {order.billingAddress && (
            <div className="order-info-section billing-info">
              <div className="section-icon">🧾</div>
              <div className="section-content">
                <h4>Adresse de facturation</h4>
                <div className="billing-address">
                  <p className="info-value">
                    {order.payerFirstName && order.payerLastName
                      ? `${order.payerFirstName} ${order.payerLastName}`
                      : order.utilisateur
                      ? `${order.utilisateur.prenom} ${order.utilisateur.nom}`
                      : "N/A"}
                  </p>
                  <p>{order.billingAddress}</p>
                  {order.billingAddressLine2 && <p>{order.billingAddressLine2}</p>}
                  <p>
                    {order.billingPostalCode} {order.billingCity}
                  </p>
                  <p>{order.billingCountry}</p>
                </div>
              </div>
            </div>
          )}

          {order.additionalInfo && (
            <div className="order-info-section additional-info">
              <div className="section-icon">📝</div>
              <div className="section-content">
                <h4>Informations supplémentaires</h4>
                <p className="additional-info-text">{order.additionalInfo}</p>
              </div>
            </div>
          )}
        </div>

        <div className="order-items-section">
          <h4>🛒 Articles commandés</h4>
          <div className="items-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Produit</th>
                  <th>Catégorie</th>
                  <th>Prix unitaire</th>
                  <th>Quantité</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.product ? item.product.id : "N/A"}</td>
                    <td>
                      {item.product && (item.product.thumbnailPath || item.product.path) && (
                        <img
                          src={`${getThumbnailUrl(item.product)}?t=${Date.now()}`}
                          alt={item.product.title}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            cursor: "pointer",
                            borderRadius: "4px",
                          }}
                          onClick={() => {
                            const imageUrl = item.product.path
                              ? `${API_BASE_URL}${item.product.path}?t=${Date.now()}`
                              : null;
                            setViewingImage(imageUrl);
                          }}
                        />
                      )}
                    </td>
                    <td>{item.product ? item.product.title : "Produit supprimé"}</td>
                    <td>
                      {item.product && item.product.category
                        ? item.product.category.name
                        : "N/A"}
                    </td>
                    <td>{item.product ? parseFloat(item.product.price).toFixed(2) : parseFloat(item.price).toFixed(2)} €</td>
                    <td>{item.quantity}</td>
                    <td>
                      {((item.product ? parseFloat(item.product.price) : parseFloat(item.price)) * item.quantity).toFixed(2)} €
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="6" style={{ textAlign: "right", fontWeight: "bold" }}>
                    Sous-total:
                  </td>
                  <td style={{ fontWeight: "bold" }}>{sousTotal.toFixed(2)} €</td>
                </tr>
                <tr>
                  <td colSpan="6" style={{ textAlign: "right", fontWeight: "bold" }}>
                    Livraison ({shippingMethod === 'pickup' ? 'Retrait en magasin' : 'Colissimo'}):
                  </td>
                  <td style={{ fontWeight: "bold" }}>{shippingCost.toFixed(2)} €</td>
                </tr>
                <tr>
                  <td colSpan="6" style={{ textAlign: "right", fontWeight: "bold" }}>
                    Total:
                  </td>
                  <td style={{ fontWeight: "bold" }}>{totalWithShipping.toFixed(2)} €</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
